export const getStatusColor = (status?: string) => {
  if (status === 'To do' || status === 'TO_DO') return 'unset';
  if (status === 'In progress' || status === 'IN_PROGRESS') return '#0288D1';
  if (status === 'Pending' || status === 'PENDING') return '#FFC107';
  if (status === 'Done' || status === 'DONE') return '#2E7D32';
  return 'unset';
};
